export default __webpack_public_path__ + "static/media/user2.94d2e1d6.svg";